import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=769e2b90&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('769e2b90')) {
      api.createRecord('769e2b90', component.options)
    } else {
      api.reload('769e2b90', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=769e2b90&", function () {
      api.rerender('769e2b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2haB0fdQBaF5U/JS/comp/childrenage.vue"
export default component.exports